<template>
    <div>
        <!-- DESKTOP: puvodni plovouci sloupec fab ikon (originalni grafika pres herni art) -->
        <div
            v-if="!isMobile"
            class="transparent ml-1 mt-2"
            style="width: 200px; position: fixed; height: calc(100vh - 20px); left: 0px; top: 20px; z-index: 3000; pointer-events: none;"
        >
            <div style="overflow: auto; width: 100%; height: 100%" class="hidescroll">
                <div style="width: 100%;" v-for="item in navItemsLocalized" :key="item.key">
                    <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                :color="getColor(item.path, item.baseColor)"
                                class="black--text ma-1 btn-shadow mr-6"
                                v-bind="attrs"
                                v-on="on"
                                link
                                :width="item.btnSize"
                                :height="item.btnSize"
                                fab
                                :to="item.to"
                                style="pointer-events:auto;"
                                :style="item.key === 'journey' ? 'box-shadow: 1px 1px 4px 3px rgba(0,0,0,0.5), -1px -2px 6px 3px rgba(0,0,0,0.65) inset' : ''"
                                @click="onNavItemClick(item)"
                            >
                                <v-icon
                                    :size="item.iconSize"
                                    style="position:relative; top: -1px;"
                                >
                                    {{ item.icon }}
                                </v-icon>
                                <v-icon v-if="item.star && trainerHasAction" size="20" style="color: #FFD700; position:absolute; top: -20px; left:-5px; filter: drop-shadow(0 0 3px rgba(0,0,0,0.9)) drop-shadow(0 0 3px rgba(0,0,0,0.9));">mdi-star</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ item.title }}</span>
                    </v-tooltip>
                </div>

                <div style="width: 100%;">
                    <div
                        v-if="isDebugUser"
                        style="height: 40px"
                        class="shrink ma-0 pa-0"
                    >
                        <v-btn
                            bottom
                            class="ma-1 mr-6"
                            fab
                            width="40"
                            height="40"
                            color="warning  black--text"
                            @click="expandLogger = true"
                            style="pointer-events:auto;"
                        >
                            <v-icon>
                                mdi-account-reactivate
                            </v-icon>
                        </v-btn>

                        <UserChanger v-model="expandLogger"/>

                        <v-btn
                            bottom
                            class="ma-1 mr-6"
                            fab
                            width="40"
                            height="40"
                            color="warning black--text"
                            @click="playersActivityOpen = true"
                            style="pointer-events:auto;"
                        >
                            <v-icon>mdi-clock-outline</v-icon>
                        </v-btn>

                        <PlayersActivityDialog v-model="playersActivityOpen"/>
                    </div>
                </div>

                <div style="width: 100%;">
                    <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                :color="getColor('/options', 'primary')"
                                class="black--text ma-1 btn-shadow"
                                v-bind="attrs"
                                v-on="on"
                                link
                                :to="{name: 'Options'}"
                                fab
                                width="40"
                                height="40"
                                style="pointer-events:auto;"
                            >
                                <v-icon>
                                    mdi-cog
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('layout.navDrawer.options') }}</span>
                    </v-tooltip>
                </div>

                <div style="width: 100%;">
                    <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                color="error"
                                class="black--text ma-1 mt-2 mr-6 btn-shadow"
                                v-bind="attrs"
                                v-on="on"
                                link
                                @click="$emit('logout')"
                                fab
                                width="40"
                                height="40"
                                style="pointer-events:auto;"
                            >
                                <v-icon
                                    style=" transform: scaleX(-1);"
                                >
                                    mdi-logout
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('layout.navDrawer.logout') }}</span>
                    </v-tooltip>
                </div>

                <div style="width: 100%;">
                    <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                color="blue"
                                class="black--text ma-1 mt-2 mr-6 btn-shadow"
                                v-bind="attrs"
                                v-on="on"
                                link
                                size="48"
                                @click="goFacebook"
                                style="pointer-events:auto; border-radius: 50%; width: 40px;height: 40px;">
                                mdi-facebook
                            </v-icon>
                        </template>
                        <span>{{ $t('layout.navDrawer.facebookGroup') }}</span>
                    </v-tooltip>
                </div>

            </div>
        </div>

        <!-- MOBIL: temporary drawer - cely obsah je jeden flex sloupec (horni seznam nahore, spodni dole, spacer mezi nimi roztahujici se na vyssich obrazovkach), misto vestaveneho Vuetify default/append chovani. overflow-y:auto je jen zachranna brzda pro extremne nizke obrazovky. -->
        <v-navigation-drawer
            v-else
            :value="value"
            @input="$emit('input', $event)"
            app
            temporary
            dark
            :right="rightHanded"
            color="rgba(33,33,33,0.97)"
            width="256"
            style="z-index: 3000;"
        >
            <div class="nav-drawer-flex">
                <v-list nav class="pa-1 nav-drawer-list--primary">
                    <v-list-item
                        v-for="item in navItemsLocalized"
                        :key="item.key"
                        :to="item.to"
                        link
                        exact
                        class="nav-item"
                        @click="onNavItemClick(item); $emit('input', false)"
                    >
                        <v-list-item-icon class="mr-4">
                            <v-badge
                                v-if="item.star && trainerHasAction"
                                color="transparent"
                                overlap
                                offset-x="10"
                                offset-y="10"
                            >
                                <template v-slot:badge>
                                    <v-icon size="16" style="color: #FFD700; filter: drop-shadow(0 0 3px rgba(0,0,0,0.9)) drop-shadow(0 0 3px rgba(0,0,0,0.9));">mdi-star</v-icon>
                                </template>
                                <v-icon size="30" :color="item.baseColor">{{ item.icon }}</v-icon>
                            </v-badge>
                            <v-icon v-else size="30" :color="item.baseColor">{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="nav-item-title">{{ item.title }}</v-list-item-title>
                    </v-list-item>
                </v-list>

                <div class="nav-drawer-spacer"/>

                <div class="nav-drawer-list--secondary">
                    <v-divider/>
                    <v-list nav class="pa-1">
                        <template v-if="isDebugUser">
                            <v-list-item class="nav-item" link @click="expandLogger = true">
                                <v-list-item-icon class="mr-3">
                                    <v-icon color="warning">mdi-account-reactivate</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t('layout.navDrawer.switchUser') }}</v-list-item-title>
                            </v-list-item>
                            <UserChanger v-model="expandLogger"/>

                            <v-list-item class="nav-item" link @click="playersActivityOpen = true">
                                <v-list-item-icon class="mr-3">
                                    <v-icon color="warning">mdi-clock-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t('layout.navDrawer.playerActivity') }}</v-list-item-title>
                            </v-list-item>
                            <PlayersActivityDialog v-model="playersActivityOpen"/>
                        </template>

                        <v-list-item class="nav-item" link @click="goFacebook">
                            <v-list-item-icon class="mr-3">
                                <v-icon color="blue">mdi-facebook</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('layout.navDrawer.facebookGroup') }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item class="nav-item" link :to="{name: 'Options'}" @click="$emit('input', false)">
                            <v-list-item-icon class="mr-3">
                                <v-icon color="grey lighten-1">mdi-cog</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('layout.navDrawer.options') }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item class="nav-item" link @click="$emit('logout')">
                            <v-list-item-icon class="mr-3">
                                <v-icon color="error">mdi-logout</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('layout.navDrawer.logout') }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </div>
            </div>
        </v-navigation-drawer>

        <TypeChartDialog v-model="typeChartOpen"/>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import UserChanger from '@/components/user/UserChanger';
    import PlayersActivityDialog from '@/components/user/PlayersActivityDialog';
    import TypeChartDialog from '@/components/dashboard/TypeChartDialog';
    import {isMobileMixin} from '@/utils/isMobileMixin';
    import {flags} from '@/config/featureFlags';

    export default {
        name: 'NavDrawer',
        components: {UserChanger, PlayersActivityDialog, TypeChartDialog},
        mixins: [isMobileMixin],
        props: {
            value: {type: Boolean, default: false},
        },
        data() {
            return {
                expandLogger: false,
                playersActivityOpen: false,
                typeChartOpen: false,
                navItems: [
                    {key: 'journey', icon: 'mdi-pokeball', to: {name: 'Journey'}, path: '/journey', baseColor: 'accent', btnSize: 60, iconSize: 55},
                    {key: 'you', icon: 'mdi-account-cowboy-hat', to: {name: 'TrainerDetail'}, path: '/you', baseColor: 'accent', btnSize: 60, iconSize: 50, star: true},
                    {key: 'trainers', icon: 'mdi-account-details', to: {name: 'Dashboard'}, path: '/dashboard', baseColor: 'primary', btnSize: 40, iconSize: 30},
                    {key: 'toplists', icon: 'mdi-trophy', to: {name: 'Toplist'}, path: '/toplist', baseColor: 'primary', btnSize: 40, iconSize: 30},
                    {key: 'skills', icon: 'mdi-star', to: {name: 'Skills'}, path: '/skills', baseColor: 'primary', btnSize: 40, iconSize: 30},
                    {key: 'pokedex', icon: 'mdi-id-card', to: {name: 'Pokedex'}, path: '/pokedex', baseColor: 'primary', btnSize: 40, iconSize: 30},
                    {key: 'types', icon: 'mdi-palette', action: 'typeChart', baseColor: 'primary', btnSize: 40, iconSize: 30},
                    {key: 'trade', icon: 'mdi-scale-balance', to: {name: 'TradeHub'}, path: '/trade', baseColor: 'primary', btnSize: 40, iconSize: 30},
                    {key: 'pvp', icon: 'mdi-sword-cross', to: {name: 'PvpHub'}, path: '/pvp', baseColor: 'error', btnSize: 40, iconSize: 30},
                    {key: 'messages', icon: 'mdi-email-outline', to: {name: 'MessageHub'}, path: '/messages', baseColor: 'error', btnSize: 40, iconSize: 30},
                    {key: 'rules', icon: 'mdi-book-open-variant', to: {name: 'GameRules'}, path: '/gameRules', baseColor: 'yellow', btnSize: 40, iconSize: 30},
                    {key: 'news', icon: 'mdi-bullhorn-outline', to: {name: 'News'}, path: '/news', baseColor: 'yellow', btnSize: 40, iconSize: 30},
                ],
            }
        },
        computed: {
            ...mapGetters({
                user: 'user/item',
                trainerHasAction: 'journey/trainerHasAction',
                isImpersonating: 'user/isImpersonating',
            }),
            isDebugUser() {
                return (this.user && this.user.name === 'Kelghor') || this.isImpersonating;
            },
            rightHanded() {
                return flags.rightHanded;
            },
            navItemsLocalized() {
                return this.navItems.map((item) => ({
                    ...item,
                    title: this.$t('layout.navDrawer.items.' + item.key),
                }));
            },
        },
        methods: {
            onNavItemClick(item) {
                if (item.action === 'typeChart') {
                    this.typeChartOpen = true;
                }
            },
            goFacebook() {
                window.open('https://www.facebook.com/groups/315092013979799', '_blank');
            },
            getColor(path, baseColor) {
                return this.$router.history.current.path === path ? baseColor + ' lighten-3' : baseColor;
            },
        },
    }
</script>

<style scoped>
/* Nahrazuje vestavene Vuetify default/append chovani (viz komentar u v-navigation-drawer v sablone vyse). overflow-y:auto je zachranna brzda pro extremne nizke obrazovky, ne bezny stav. */
.nav-drawer-flex {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
}
/* Roztahne se na nadbytecne vysokych obrazovkach, at horni seznam drzi nahore a spodni dole. */
.nav-drawer-spacer {
    flex: 1 1 auto;
    min-height: 0;
}
/* Pripraveno pro budouci theme/skin odliseni - zatim schvalne beze zmeny vzhledu. */
.nav-drawer-list--primary {
}
.nav-drawer-list--secondary {
}
.nav-item {
    /* Zmenseno z puvodnich 54px - ikona/font zustavaji, jen se zmensuje prazdny prostor kolem. */
    min-height: 44px;
    /* Vuetify da "v-list--nav .v-list-item" defaultne margin-bottom: 8px - !important stejna specificita jako Vuetify pravidlo, potrebuje vyhrat. */
    margin-bottom: 0 !important;
    /* Odstin mezi polozkami - kazdy v-list ma vlastni posledni prvek bez ramecku, aby se nezdvojoval s v-divider mezi hornim a spodnim seznamem. */
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.nav-item:last-child {
    border-bottom: none;
}
.nav-item-title {
    font-size: 17px;
    font-weight: 500;
}
/* Vuetify da ikone vlastni align-self:flex-start (na rozdil od contentu/title, ktere maji center) - drive to fungovalo jen diky tomu, ze stejny margin nahore i dole ji opticky vycentroval; po vynulovani marginu je potreba align-self:center primo. */
.nav-item ::v-deep .v-list-item__icon {
    margin-top: 0;
    margin-bottom: 0;
    align-self: center;
}
</style>
